import { ComponentProps } from "react";
import ReactGA from "react-ga4";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router";

import styles from "@components/v1/ActivateButton.module.css";
import Button from "@components/v2/buttons/Button";
import useCreateActivationAnalyticsEvent from "@hooks/mutations/useCreateActivationAnalyticsEvent";
import { ClientTopicOfInterestEnum } from "@typing/Generated";
import storage from "@utils/storageUtils";

type Props = Pick<ComponentProps<typeof Button>, "className"> & {
  topic: ClientTopicOfInterestEnum;
};

const ActivateButton = ({ className, topic }: Props) => {
  const history = useHistory();

  const createActivationAnalyticsEvent = useCreateActivationAnalyticsEvent({ action: "click", topic });

  const handleClick = () => {
    createActivationAnalyticsEvent();
    if (import.meta.env.VITE_GOOGLE_ANALYTICS_ID) {
      ReactGA.event("activate-click", { topicOfInterest: topic });
    }
    storage.set("topicOfInterest", topic).then(() => {
      history.push("/sign-up");
    });
  };

  const classNames = [styles.activateButton];
  if (className) classNames.push(className);

  return (
    <Button className={classNames.join(" ")} color="secondary" onClick={handleClick}>
      <FormattedMessage id="components.ActivateButton.cta" />
    </Button>
  );
};

export default ActivateButton;
